import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/helpers/axiosInstance';

export const fetchInteractionById = createAsyncThunk(
  'interaction/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/interactions/get-interaction-info-by-id/${id}`);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch interaction');
    }
  }
);

export const updateFlowStepApi = createAsyncThunk(
  'interaction/updateFlowStep',
  async ({ id, flow_step }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/interactions/update-flow-step/${id}`, { flow_step });
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update flow step');
    }
  }
);


